import { TFunction } from 'i18next';

/**
 * Generates CSS for the header dropdown labels using translations.
 * This ensures "Heading 1", "Heading 2", "Normal" are replaced with
 * translated "Title", "Subtitle", "Paragraph" labels.
 */
export function getHeaderDropdownCss(t: TFunction): string {
  const titleLabel = t('editor.rte.title');
  const subtitleLabel = t('editor.rte.subtitle');
  const paragraphLabel = t('editor.rte.paragraph');

  return `
    /* Header dropdown - Paragraph (default/false value) */
    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
      content: '${paragraphLabel}' !important;
    }

    /* Header dropdown - Title (h1) */
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
      content: '${titleLabel}' !important;
    }

    /* Header dropdown - Subtitle (h2) */
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
      content: '${subtitleLabel}' !important;
    }
  `;
}

/**
 * Generates CSS for toolbar styling improvements:
 * - Light grey/white background with black font for better readability
 * - Improved scrollbar visibility in dropdowns and editor
 */
export function getToolbarStylesCss(): string {
  return `
    /* Toolbar background styling - light grey/white with black font */
    .ql-toolbar.ql-snow {
      background-color: #f8f9fa !important;
      border-color: #dee2e6 !important;
    }

    .ql-toolbar.ql-snow .ql-picker-label,
    .ql-toolbar.ql-snow .ql-picker-label::before,
    .ql-toolbar.ql-snow button {
      color: #212529 !important;
    }

    .ql-toolbar.ql-snow .ql-stroke {
      stroke: #212529 !important;
    }

    .ql-toolbar.ql-snow .ql-fill {
      fill: #212529 !important;
    }

    .ql-toolbar.ql-snow .ql-picker-options {
      background-color: #ffffff !important;
      border-color: #dee2e6 !important;
    }

    .ql-toolbar.ql-snow .ql-picker-item {
      color: #212529 !important;
    }

    .ql-toolbar.ql-snow .ql-picker-item:hover {
      background-color: #e9ecef !important;
    }

    /* Scrollbar styling for dropdowns (when naturally scrollable) */
    .ql-picker-options::-webkit-scrollbar {
      width: 8px;
    }

    .ql-picker-options::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }

    .ql-picker-options::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 4px;
    }

    .ql-picker-options::-webkit-scrollbar-thumb:hover {
      background: #555;
    }

    /* Firefox scrollbar styling for dropdowns */
    .ql-picker-options {
      scrollbar-width: thin;
      scrollbar-color: #888 #f1f1f1;
    }

    /* Improved scrollbar visibility in the editor content area */
    .ql-editor::-webkit-scrollbar {
      width: 8px;
    }

    .ql-editor::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }

    .ql-editor::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 4px;
    }

    .ql-editor::-webkit-scrollbar-thumb:hover {
      background: #555;
    }

    /* Firefox scrollbar styling for editor */
    .ql-editor {
      scrollbar-width: thin;
      scrollbar-color: #888 #f1f1f1;
    }
  `;
}
